// components/WarningModal.js
const WarningModal = ({ warningCount, onClose }) => {
  return (
    <div className="warning-modal-overlay">
      <div className="warning-modal">
        <div className="warning-header">
          <h2>⚠️ Warning</h2>
        </div>
        <div className="warning-content">
          <p><strong>Violation Detected!</strong></p>
          <p>You have violated quiz rules by:</p>
          <ul>
            <li>Switching tabs/windows OR</li>
            <li>Minimizing window OR</li>
            <li>Using restricted shortcuts</li>
          </ul>
          <p><strong>Warning {warningCount} of 3</strong></p>
          <p>After 3 warnings, the quiz will auto-submit.</p>
        </div>
        <button onClick={onClose} className="btn-warning">
          I Understand
        </button>
      </div>
    </div>
  );
};

export default WarningModal;